import axios from "axios";
import {
    IndividualContractorDTO, UpdateIndividualContractorDetailsPayload
} from "@/components/payroll/business/employments/contractors/Contractor";
import {INDIVIDUAL_CONTRACTOR_SERVICE} from "@/constants/endpoints";
import authHeader from "@/services/auth-header";
import TerminationPayloadDTO from "@/components/payroll/business/employments/contractors/TerminationPayloadDTO";

class IndividualContractorService {
    public getContractorById(contractorId: number) {
        return axios.get<IndividualContractorDTO>(`${INDIVIDUAL_CONTRACTOR_SERVICE}/${contractorId}`, {headers: authHeader()})
    }

    public terminateContractor(payload: TerminationPayloadDTO) {
        return axios.put(`${INDIVIDUAL_CONTRACTOR_SERVICE}/terminate`, payload, {headers: authHeader()})
    }

    public deleteContractor(contractorId: number) {
        return axios.delete(`${INDIVIDUAL_CONTRACTOR_SERVICE}/${contractorId}`, {headers: authHeader()})
    }

    public updateContractor(payload: UpdateIndividualContractorDetailsPayload) {
        return axios.put(`${INDIVIDUAL_CONTRACTOR_SERVICE}`, payload, {headers: authHeader()})
    }
}

export default new IndividualContractorService();